<template>
  <div class="card card-exito shadow-lg p-5 rounded-4 mx-auto text-center" style="max-width:480px;">
    <h3 class="titulo-exito fw-bold mb-3">{{ $t('pronostico.paymentCompleted') }}</h3>
    <p class="subtitulo-exito mb-4">{{ $t('pronostico.forecastAvailable') }}</p>
    <a v-if="enlaceGenerado" :href="enlaceGenerado" target="_blank" class="enlace-pronostico">{{ enlaceGenerado }}</a>
    <p v-else class="text-warning mt-2">{{ $t('pronostico.linkPending') }}</p>
    <p class="agradecimiento-final mt-4">
      <strong>{{ $t('pronostico.thanks') }}</strong><br>
      {{ $t('pronostico.enjoy') }}
    </p>
  </div>
</template>

<script>
export default {
  name: "PronosticoPagoCompletado",
  props: {
    enlaceGenerado:  { type: String,  default: "" },
    importe:         { type: Number,  default: 0 },
    moneda:          { type: String,  default: "EUR" },
    transactionId:   { type: String,  default: "" },
    itemName:        { type: String,  default: "" },
  },
};
</script>
